export const SALES_PHONE_NUMBER = '0176421408';
export const CSM_PHONE_NUMBER = '0757915604';
